var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaskgroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38064_24427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50092 16.5C9.48601 16.5012 10.4616 16.3078 11.3717 15.9308C12.2818 15.5538 13.1085 15.0007 13.8042 14.3033C14.5016 13.6076 15.0547 12.7809 15.4317 11.8708C15.8087 10.9607 16.0021 9.9851 16.0009 9.00001C16.0021 8.01491 15.8087 7.03929 15.4317 6.12919C15.0547 5.21909 14.5016 4.39245 13.8042 3.69676C13.1085 2.99932 12.2818 2.44621 11.3717 2.06922C10.4616 1.69223 9.48601 1.49879 8.50092 1.50001C7.51583 1.49879 6.54021 1.69223 5.63011 2.06922C4.72 2.44621 3.89336 2.99932 3.19767 3.69676C2.50023 4.39245 1.94713 5.21909 1.57014 6.12919C1.19315 7.03929 0.999706 8.01491 1.00092 9.00001C0.999706 9.9851 1.19315 10.9607 1.57014 11.8708C1.94713 12.7809 2.50023 13.6076 3.19767 14.3033C3.89336 15.0007 4.72 15.5538 5.63011 15.9308C6.54021 16.3078 7.51583 16.5012 8.50092 16.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.575,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50107 4.125C8.74971 4.125 8.98817 4.22377 9.16398 4.39959C9.3398 4.5754 9.43857 4.81386 9.43857 5.0625C9.43857 5.31114 9.3398 5.5496 9.16398 5.72541C8.98817 5.90123 8.74971 6 8.50107 6C8.25243 6 8.01397 5.90123 7.83816 5.72541C7.66234 5.5496 7.56357 5.31114 7.56357 5.0625C7.56357 4.81386 7.66234 4.5754 7.83816 4.39959C8.01397 4.22377 8.25243 4.125 8.50107 4.125Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68811 12.75V7.5H7.93811M7.37561 12.75H10.0006",
    stroke: "black",
    strokeWidth: 1.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38064_24427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.500061 0H17.4999V18H-0.500061V0Z",
    fill: "#FFD233"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskgroup);
export default __webpack_public_path__ + "static/media/maskgroup.598e4456d80b5f648733ccd329d0790d.svg";
export { ForwardRef as ReactComponent };